// services/service.services.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IService } from "../serviceModal";

export const getAllServices = createAsyncThunk(
  "Service/FindAllService",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/FindAllService`,
        { Title: "" },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Services:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createService = createAsyncThunk(
  "Service/InsertService",
  async (serviceData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/InsertService`,
        serviceData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateService = createAsyncThunk(
  "Service/UpdateService",
  async (serviceData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/UpdateService`,
        serviceData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteService = createAsyncThunk(
  "Service/DeleteService",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/DeleteService`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getServiceByID = createAsyncThunk(
  "Service/FindByIDService",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/FindByIDService`,
        { ID },
      );
      const result = response.data?.Data;
      return {
        ID: result?.ID,
        Title: result?.Title,
        URL: result?.URL,
        Tagline: result?.Tagline,
        ShortDescription: result?.ShortDescription,
        LongDescription: result?.LongDescription,
        KeyFeature: result?.KeyFeature,
        SequenceNo: result?.SequenceNo,
        MetaTitle: result?.MetaTitle,
        MetaKeywords: result?.MetaKeywords,
        MetaDescription: result?.MetaDescription,
        IconImage: result?.IconImage,
        MainImage: result?.MainImage,
        BannerImage: result?.BannerImage,
        IsActive: result?.IsActive ? 1 : 2,
      } as IService;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveServices = createAsyncThunk(
  "Service/FindAllActiveService",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Service/FindAllActiveService`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Active Services:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const activeInactiveService = createAsyncThunk(
  "Service/ActiveInActiveService",
  async (formData: { ID: number; IsActive: boolean }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/ActiveInActiveService`,
        formData,
      );
      SuccessToast(response.data?.Details || "Status updated successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const serviceImageUpload = createAsyncThunk(
  "Service/SingleImageUpload",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/SingleImageUpload`,
        formData,
        { headers: { "content-type": "multipart/form-data" } },
      );
      SuccessToast(response.data?.Details || "Images uploaded successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error uploading Service images:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
